import { useDisclosure } from "@chakra-ui/hooks";
import { Modal, ModalBody, ModalContent, ModalOverlay , ModalHeader , ModalFooter } from "@chakra-ui/modal";
import React from "react";
import Card from "components/card/custom";
import { BsInfoCircleFill } from "react-icons/bs";
import { MdCheck, MdFileCopy, MdHighlightOff } from "react-icons/md";
import { ClientContext } from "ClientProvider";
import {useContext} from "react";
import { Popover, PopoverTrigger, PopoverContent, PopoverHeader , PopoverArrow } from "@chakra-ui/react";
import { Portal } from '@chakra-ui/portal'

const InfoModal = ({ info, varient  }: { info?: any, varient?: string}) => {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [copyPayment, setCopyPayment] = React.useState<boolean>(false)
    const { singleRoleData } = useContext(ClientContext);
    const act_tab = "Gateway Response"

    const [activeTab, setActiveTab] = React.useState<string>(act_tab)
    const [isCloseModal, setIsCloseModal] =  React.useState<boolean>(false);
    const handleClose = () => {
        setIsCloseModal(true)
        setTimeout(() => {
        setIsCloseModal(false)
        onClose();
        }, 300);
    };

    let parsed_response: any = {};

    try {
        if (info) {
            if (typeof info === "string") {
                const fixed = info
                    .replace(/\bNone\b/g, "null")
                    .replace(/\bFalse\b/g, "false")
                    .replace(/\bTrue\b/g, "true")
                    .replace(/([{,]\s*)'([^']+)'\s*:/g, '$1"$2":')
                    .replace(/:\s*'([^']*)'/g, ': "$1"');

                parsed_response = JSON.parse(fixed);
            } else if (typeof info === "object") {
                parsed_response = info;
            }
        }
    } catch (e) {
        parsed_response = {};
    }

    
  return (
    <>
        {singleRoleData?.[0]?.crypto?.value?.view_crypto_payout_response_information && (
            <Popover trigger="hover" placement="bottom">
                <PopoverTrigger>
                    <button
                        className="flex disabled:opacity-50 disabled:cursor-not-allowed items-center justify-center gap-2 whitespace-nowrap px-3 py-2 text-blue-500 outline-none dark:text-gray-200"
                        onClick={() => { onOpen() }}
                    >
                        <BsInfoCircleFill className={varient === "small" ? "h-4 w-4" : "w-5 h-5"} />
                    </button>
                </PopoverTrigger>  
                {/* <Portal >  */}
                <PopoverContent borderColor='blue.800' className="z-20 dark:bg-gray-800 shadow  invisible inline-block text-sm text-gray-500 transition-opacity duration-300 bg-white border border-gray-200 rounded-lg shadow-sm opacity-0 dark:text-gray-400 dark:border-gray-600 dark:bg-gray-800 p-3 border-6 shadow !bg-gray-700">
                    <PopoverHeader>
                    <span className="text-sm  font-bold text-white">
                    View Payout Information
                    </span>
                    </PopoverHeader>
                    <PopoverArrow  className="border h-8 w-8 border-gray-700 !bg-gray-700  "  />
                </PopoverContent>
                {/* </Portal> */}
            </Popover>
            
        )}
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay className="bg-[#000] !opacity-30" />
            <Card extra={`fixed top-0 right-0 h-full rounded-none max-w-[600px] sm:w-full flex flex-col justify-start !z-[1004] overflow-y-auto scrollbar-hide overflow-auto ${
                isOpen && !isCloseModal ? "card-enter" : "card-exit"
            }`}>
                <ModalHeader className="py-[20px] mb-[20px] px-[30px] text-2xl font-bold bg-brand-500 text-white">
                
                    <MdHighlightOff
                        className="absolute right-7 top-6 h-8 w-8 cursor-pointer text-white"
                        onClick={handleClose}
                    />
                {activeTab}
                </ModalHeader>
                <ModalBody className="p-2">
                
                {activeTab == "Gateway Response" && (
                    <>
                    <div className="  relative flex flex-col overflow-auto mx-[35px] rounded-xl border border-gray-100  scrollbar scrollbar-h-1.5 scrollbar-track-gray-100 scrollbar-thumb-gray-300 scrollbar-track-rounded-full scrollbar-thumb-rounded-xl scrollbar-w-1.5  !overflow-auto max-w-[75vw]">
                        <pre className="p-2">{JSON.stringify(parsed_response, null, 2)}</pre>
                        <div className="absolute top-3 right-3 outline-none">
                        {copyPayment ?
                            <MdCheck className="cursor-pointer text-teal-500 mr-4"/>
                            :
                            <MdFileCopy
                            className="cursor-pointer text-teal-500 mr-4"
                            onClick={() => {
                                navigator.clipboard.writeText(JSON.stringify(parsed_response, null, 2))
                                setCopyPayment(true);
                                setTimeout(() => { setCopyPayment(false) }, 1500)
                            }}
                            />}
                        </div>
                    </div>
                    </>
                )}
                </ModalBody>
                <ModalFooter className="mt-[10px]">
                    <div className="mt-5 flex gap-2 px-[30px] pb-[30px]">
                    <button
                        onClick={handleClose}
                        className="linear rounded-xl bg-indigo-600 px-5 py-2 text-white font-medium text-navy-700 outline-none transition duration-200 hover:bg-indigo-500 active:bg-indigo-500 dark:bg-white/10 dark:text-white dark:hover:bg-white/20 dark:active:bg-white/30"
                        // className="outline-none linear rounded-xl bg-gray-100 px-5 py-2 text-base font-medium text-navy-700 transition duration-200 hover:bg-gray-200 active:bg-gray-300 dark:bg-white/10 dark:text-white dark:hover:bg-white/20 dark:active:bg-white/30"
                    >
                        Close
                    </button>
                    </div>
                </ModalFooter>
            </Card>
         </Modal>
    </>
  );
};
export default InfoModal;
